/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ n: NonNullable<unknown> }} Platform_Rail_WeekInputs */

const en_platform_rail_week = /** @type {(inputs: Platform_Rail_WeekInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`W${i?.n}`)
};

const pl_platform_rail_week = /** @type {(inputs: Platform_Rail_WeekInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`T${i?.n}`)
};

/**
* | output |
* | --- |
* | "W{n}" |
*
* @param {Platform_Rail_WeekInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const platform_rail_week = /** @type {((inputs: Platform_Rail_WeekInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Platform_Rail_WeekInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_platform_rail_week(inputs)
	return en_platform_rail_week(inputs)
});